import OnboardingModal from './onboarding-modal'

export default OnboardingModal
